import React from 'react';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';

import styles from './PatientAutoVerify.module.scss';

interface Props {
	isOpen: boolean;
	errorMessage?: string;
	onRetry: () => void;
	onClose: () => void;
}

const PatientAutoVerifyErrorModal: React.FC<Props> = ({
	isOpen,
	errorMessage,
	onRetry,
	onClose,
}) => (
	<BaseModal
		isOpen={isOpen}
		onClose={onClose}
		title='nczi.patientAutoVerify.errorTitle'>
		<>
			<Text tx='nczi.patientAutoVerify.errorText' firstUpper />
			{!!errorMessage && (
				<Text tx={errorMessage} className={styles.errorMessage} />
			)}
			<div className={styles.controls}>
				<Button
					theme={Theme.BLUE}
					title='base.repeat'
					onClick={onRetry}
					fitContent
				/>
				<LinkButton
					theme={Theme.RED}
					title='base.shared.close'
					onClick={onClose}
					fitContent
				/>
			</div>
		</>
	</BaseModal>
);

export default PatientAutoVerifyErrorModal;
